// This is a .js file so it can be imported in next.config.js
// Don't use this file directly, use @/globals/config/helpers/configEnvironment instead

/** @type {readonly import("./configEnvironment.types").NodeEnv[]} */
export const nodeEnvOptions = Object.freeze([
	'development',
	'test',
	'production',
]);

/** @type {readonly import("./configEnvironment.types").Project[]} */
export const projectOptions = Object.freeze(['op', 'bgov']);

/** @type {readonly import("./configEnvironment.types").Environment[]} */
export const environmentOptions = Object.freeze([
	'local',
	'tst',
	'acp',
	'staging',
	'prd',
]);

/** @type {readonly import("./configEnvironment.types").HostEnv[]} */
export const hostEnvOptions = Object.freeze(['localhost', 'server']);

/**
 * Assert that a value is one of the allowed values
 * @template T
 * @param {string} envValue - The value to check
 * @param {readonly T[]} allowedValues - The array of allowed values
 * @param {T} [defaultValue] - Default value if original value is invalid
 * @returns {T | undefined} - Type assertion
 */
const getEnvItem = (envValue, allowedValues, defaultValue) => {
	const value = envValue || defaultValue;
	if (!allowedValues.includes(value)) {
		return undefined;
	}
	return value;
};

/**
 * Get the environment configuration
 */
export const getConfigEnvironment = () => {
	const nodeEnv = getEnvItem(process.env.NODE_ENV, nodeEnvOptions);
	const project = getEnvItem(process.env.NEXT_PUBLIC_PRJ, projectOptions);
	const environment = getEnvItem(
		process.env.NEXT_PUBLIC_ENV,
		environmentOptions,
	);
	const hostEnv = getEnvItem(process.env.NEXT_PUBLIC_HOST_ENV, hostEnvOptions);

	return { nodeEnv, project, environment, hostEnv };
};
